
import DetailsDrawer from 'layouts/Hyperdrive/DriverAnalytics/CheckInOut/DetailsDrawer'
import React from 'react'

export default function CheckInOut({ closeModal }) {
    return (
        <DetailsDrawer closeModal={closeModal} />
    )
}
